export type ClientLogoDefinition = {
  height: number
  width: number
}

const CLIENT_LOGO_DEFINITIONS: Record<string, ClientLogoDefinition> = {
  "/logos/brands/cpanel.svg": { width: 861, height: 305 },
  "/logos/brands/dickies.svg": { width: 486, height: 264 },
  "/logos/brands/ethan-allen.svg": { width: 1600, height: 153 },
  "/logos/brands/live-nation.svg": { width: 184, height: 40 },
  "/logos/brands/lodge.svg": { width: 432, height: 260 },
  "/logos/brands/sectigo.svg": { width: 2259, height: 539 },
  "/logos/brands/colgin.svg": { width: 124, height: 49 },
}

export function normalizeClientLogoSrc(src: string | null | undefined): string | null {
  const normalized = src?.trim()
  return normalized ? normalized : null
}

export function getClientLogoDefinition(src: string | null | undefined): ClientLogoDefinition | null {
  const normalized = normalizeClientLogoSrc(src)
  if (!normalized) return null
  return CLIENT_LOGO_DEFINITIONS[normalized] ?? null
}
